export function getClientWithStatus(factory, key, trafficType) {
    const client = (key ? factory.client(key, trafficType) : factory.client());
    if (!client._trackingStatus) {
        // We cannot use event listeners, since clients might be already Ready or Timedout
        client.ready().then(() => {
            client.isReady = true;
        }).catch(() => {
            client.isTimedout = true;
            // register a listener for SDK_READY event, that might trigger after a timeout
            client.once(client.Event.SDK_READY, () => {
                client.isReady = true;
            });
        });
        client._trackingStatus = true;
        client.isReady = false;
        client.isTimedout = false;
    }
    return client;
}



// WEBPACK FOOTER //
// /root/urbanmassage/node_modules/@splitsoftware/splitio-react/es/utils.js